// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModalView-module__modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(38, 54, 67, 0.9);
  box-shadow: 0px 2px 4px 0px #0000001a;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  overflow: hidden;
  transition: opacity 0.3s ease-in-out;
}

.ModalView-module__modalClosed {
  opacity: 0;
}

.ModalView-module__modalOpen {
  opacity: 1;
}

.ModalView-module__modalContent {
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
}

.ModalView-module__contentClosed {
  transform: scale(0.7) translateY(-50px);
  opacity: 0;
}

.ModalView-module__contentOpen {
  transform: scale(1) translateY(0);
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/modals/modalview/ModalView.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,uCAAuC;EACvC,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,uCAAuC;EACvC,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,UAAU;AACZ","sourcesContent":[".modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(38, 54, 67, 0.9);\n  box-shadow: 0px 2px 4px 0px #0000001a;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  overflow: hidden;\n  transition: opacity 0.3s ease-in-out;\n}\n\n.modalClosed {\n  opacity: 0;\n}\n\n.modalOpen {\n  opacity: 1;\n}\n\n.modalContent {\n  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;\n}\n\n.contentClosed {\n  transform: scale(0.7) translateY(-50px);\n  opacity: 0;\n}\n\n.contentOpen {\n  transform: scale(1) translateY(0);\n  opacity: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `ModalView-module__modal`,
	"modalClosed": `ModalView-module__modalClosed`,
	"modalOpen": `ModalView-module__modalOpen`,
	"modalContent": `ModalView-module__modalContent`,
	"contentClosed": `ModalView-module__contentClosed`,
	"contentOpen": `ModalView-module__contentOpen`
};
export default ___CSS_LOADER_EXPORT___;
